import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService } from '../services/users/users.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm!: FormGroup;
  submitting = false;a
  successMessage = '';
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private usersService: UsersService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.registerForm = this.fb.group({
      lastName: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      cnp: ['', [Validators.required, Validators.pattern(/^\d{13}$/)]],
      address: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9+\-\s()]{10,}$/)]],
      email: ['', [Validators.required, Validators.email]],
      
      // Checkbox-uri
      hasAccount: [false],
      noAccountButAgree: [false],
      gdprPortalConsent: [false, [Validators.requiredTrue]],
      ciEmailConsent: [false, [Validators.requiredTrue]],
      ciSecretariatConsent: [false, [Validators.requiredTrue]],
      
      // Semnătură
      signature: ['']
    });

    // Logică pentru checkboxuri mutual exclusive
    this.registerForm.get('hasAccount')?.valueChanges.subscribe(value => {
      if (value) {
        this.registerForm.get('noAccountButAgree')?.setValue(false);
      }
    });

    this.registerForm.get('noAccountButAgree')?.valueChanges.subscribe(value => {
      if (value) {
        this.registerForm.get('hasAccount')?.setValue(false);
      }
    });

    // Logică pentru CI: trebuie să alegi una dintre cele două opțiuni
    this.registerForm.get('ciEmailConsent')?.valueChanges.subscribe(value => {
      if (value) {
        this.registerForm.get('ciSecretariatConsent')?.setValue(false);
      }
    });

    this.registerForm.get('ciSecretariatConsent')?.valueChanges.subscribe(value => {
      if (value) {
        this.registerForm.get('ciEmailConsent')?.setValue(false);
      }
    });
  }

  onSubmit(): void {
    // Marchează toate câmpurile ca touched pentru a afișa erorile
    Object.keys(this.registerForm.controls).forEach(key => {
      this.registerForm.get(key)?.markAsTouched();
    });

    if (this.registerForm.invalid) {
      this.errorMessage = 'Vă rugăm să completați toate câmpurile obligatorii corect.';
      return;
    }

    // Validare personalizată: trebuie să selectezi cel puțin una dintre opțiunile CI
    const ciEmail = this.registerForm.get('ciEmailConsent')?.value;
    const ciSecretariat = this.registerForm.get('ciSecretariatConsent')?.value;

    if (!ciEmail && !ciSecretariat) {
      this.errorMessage = 'Trebuie să selectați una dintre opțiunile de depunere CI.';
      return;
    }

    this.submitting = true;
    this.successMessage = '';
    this.errorMessage = '';

    const formData = this.registerForm.value;

    // this.usersService.registerPatient(formData).subscribe({
    //   next: (response) => {
    //     this.submitting = false;
    //     this.successMessage = 'Cererea dvs. a fost trimisă cu succes! Veți primi un email de confirmare în curând.';
    //     this.toastr.success('Cerere trimisă cu succes!', 'Înregistrare');
        
    //     // Resetează formularul după 2 secunde
    //     setTimeout(() => {
    //       this.resetForm();
    //       this.router.navigate(['/login']); // sau altă pagină
    //     }, 2000);
    //   },
    //   error: (error) => {
    //     this.submitting = false;
    //     this.errorMessage = 'A apărut o eroare la trimiterea cererii. Vă rugăm încercați din nou.';
    //     this.toastr.error('Eroare la trimiterea cererii', 'Eroare');
    //     console.error('Registration error:', error);
    //   }
    // });
  }

  resetForm(): void {
    this.registerForm.reset();
    this.successMessage = '';
    this.errorMessage = '';
    
    // Resetează valorile boolean explicit
    this.registerForm.patchValue({
      hasAccount: false,
      noAccountButAgree: false,
      gdprPortalConsent: false,
      ciEmailConsent: false,
      ciSecretariatConsent: false
    });
  }
}
